module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_127430-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_127430-00001"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "#/a9781847677099_tableofcontents"
    }
  }, [_vm._v("Hope")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00001"
    }
  }, [_vm._v("1")]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00002"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("AS THE AMBULANCE")]), _vm._v(" blares towards the Infirmary, I try to look as out-of-it as seems necessary. Can a hundred paracetamol kill you? That’s what I told them so they wouldn’t make me vomit. The driver tells me not to worry, he’s only put the siren on to emotionally blackmail his way through the traffic. They can’t pump your stomach with paracetamol, can they? When Julian swallowed them that time, all the blood vessels burst on his face and his tongue went black. Or maybe that was the Cabernet Sauvignon.")]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00003"
    }
  }, [_vm._v("The wee lassie that attached me to the monitor looks about twelve. She looked pissed-off when my vital signs showed up normal. I know how to read them having watched Dad slowly die on one. She and her even tinier mate have just carried me from the middle of Saughton Park to the main road. I called 999 from the phone box outside Davie’s, then staggered over there.")]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("When we get up to the hospital, I wait until they’re busying themselves with the ramp and stretcher before pulling free of the monitor and leaping out into the glow of A & E. As I hit the ground running, I’m halfway across Lauriston Place before they register what’s happened. The driver is a fast-moving blur behind me as I sprint into Forrest Road. By the time I get to Desiree’s flat on George IV Bridge he’s obviously re-read his job description and given up. I have no complaints about the NHS. I’ve always found it very hospitable.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("Desiree’s out for the count by the time I arrive, having just received a cassette stuffed with supergrass from Eartha in Laos. A rather misguided children’s charity gave Eartha a grant to go there, bugger street kids and post marijuana to his pals for six months. It makes you realise what Comic Relief is really about. I’m going to send them a proposal. Get out of here. Go somewhere hot.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("I knock back half a glass of red wine and skin-up before bothering to look up and see who’s here. There’s always a full complement of people in this room. Some come once, can’t handle the slagging fags and never return. Others visit weekly or every few days. Some never seem to leave. Desiree and Eartha usually hold court but in their absence it is rather like a chat show without a host. Splinter groups have been established. They are all probably bitching fiercely about one another. Noticing a woman in her sixties sitting with the pigeon sisters, I wonder if she’s our David Dimbleby for the evening.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("I slowly start to take in everybody else although I know it’s fruitless. There’s never any talent here. I’ve had my cock sucked by a couple of them but only ever through blind drunkenness or unbridled desperation.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("Jason squeezes my shoulder and hands me a copy of some treacherously stapled literary mag from the North East. He wants me to look at a poem he has in it and watches my reaction as I read. It is a self-obsessed navel contemplation and as predictably shit as the rest of his stuff. Jason’s high opinion of himself really makes me cringe. If there’s one thing I hate it’s those poor-me-tormented-writer types. Handing the magazine back I feign interest nonetheless and ask if he has anything else in the pipeline.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("‘I wish. Nobody’s interested these days if it’s not about asylum seekers or talking dogs. Nobody wants real literature any more.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("‘Couldn’t you stick a few gypsies in to keep the punters happy?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("He stomps away, feigning offence.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00014"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("As I spark up the joint, I turn my attention back to the pigeon sisters. Coo is in the midst of an astronomical phase and has been boring the tits off us all for weeks with his black holes and supernovas. Doo has started going to saunas again to illustrate his disquiet. As Coo rambles on about Stephen Hawking’s universe, Doo keeps trying to get the conversation down to his level.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00015"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("‘Honestly though, if they have the technology to leapfrog ")]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("galaxies surely they could get a better voice for the poor guy.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00016"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("The old woman chortles.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘… don’t you think though, a nice wee Sean Connery or something? Intershtellar coshmanaughtsh. Much more believable.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00018"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("Coo is blushing and flustered.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00019"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘Oh, you’re such an ignorant prick. Your brain’s the size of a sixteenth. There’s no room for anything new in there,’ he says, banging his temple for emphasis. Clattering his chair dramatically, he proffers his back to Doo and attention to the old woman.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00020"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘I’ve never met him before tonight, honestly. Intelligent conversation, please, before I lose all faith in humanity. What are your thoughts on cosmology and the search for dark matter, pray tell?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00021"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("The old woman winks at Doo and smiles.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00022"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘I’m awfully sorry dear. I watched a couple of documentaries about that chap, but the only thing that really struck me was that so many eminent scientists have subscriptions to "), _c('i', [_vm._v("Penthouse")]), _vm._v(".’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00023"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("The comment seems to focus everyone’s attention on her.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00024"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("Shirley drapes an arm around me. I hadn’t even noticed he was here.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00025"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘Speaking of which, Dionne, I’d like you to meet Hope, my auntie. She’s been festering away in her huge New Town ")]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("penthouse since my uncle died. I thought we could do with having someone old and wise round for a change.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00026"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘Hey, less of the wise,’ she smirks, raising her glass to me. ‘Dionne, is that your real name?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("I can’t even remember why or how we ended up addressing each other in such ridiculous ways and suddenly realise how sad it is.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00028"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘Martin … Martin Bell as it happens.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00029"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘Now he IS an alien,’ Doo butts in. Hope blanks him.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00030"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘Then I’ll call you Martin if you don’t mind. These Las Vegas names are all very well but I prefer Hope to Despair.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00031"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘Absolutely.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00032"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("Numerous joints circle the table. When Hope is passed one she takes a long draw then blows a smoke ring. She’s cool. Not as old as I thought at first, maybe just late fifties, with a Marianne Faithfull sort of clumsy elegance. Intrigued, I pick up my drink and go over.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00033"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("No sooner have I sat down than Shirley has his big arse squeezed on the back of my chair and whispers unsubtly in my ear, ‘Auntie’s climbing the walls in that huge flat. See if she fancies a lodger. You must get out that smelly place you’re in.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("I push him away awkwardly as Hope frowns and shakes her head.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00035"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘Honestly, Angus, I’m not senile, you know? I do still have control over my power of speech. I’ve no doubt Martin does too.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00037"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("The room erupts in laughter. Angus! He told us his real name was Andrew. No wonder he makes us call him Shirley. We try and out-do each other with crap Angus/sheep-shagger jokes until I notice Hope’s eyes starting to glaze over and don’t want to seem as arse-ish as the rest of them.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00038"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘Come on girls, it’s like the bloody Gang Show in here. Anyone would think we were smoking real blow.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00039"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("The door goes. It’s a couple of guys Shirley knows from the Traverse, very fuckable but straight, I’ve already asked. In line with flat decorum they immediately uncork a bottle of Jacob’s Crack and start skinning-up. The effect the youngest guest has on the assembled queens is rather like that of a discarded fish supper on seagulls. I regale Hope with my observation.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00040"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘And he thinks I don’t get out much!’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00041"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("It’s nice to have someone look me in the eye when they talk to me without reading something into it for a change.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00042"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘I didn’t even know Shirl … Angus had an auntie, or a family for that matter. I just assumed someone had found him in a cabbage patch in London Road in the mid-eighties and handed him in at the Laughing Duck.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00043"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("Hope pulls a face.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00044"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘We don’t really have a family as such. First and second generation black sheep, far too garish for beige people like them.’ She gestures to Shirley. ‘His father’s a church elder, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("you know, not that the implication of that is what it used to be.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00045"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("Replenishing my drink from one of the army of bottles, I offer her some. Fumbling in a carpetbag by her side she produces a half bottle of Ten-Year-Old Macallan’s and pours herself a navvy’s measure. Shirley sidles through from the kitchen, topping up Hope’s glass with hot water, blood orange juice, a spoonful of Tate and Lyle and a stir.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00046"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("Hope gives him a smile of appreciation, takes a little sip and hugs herself.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00047"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘It was my only precondition of coming here tonight. I bring my own bottle though or he tries to palm me off with that revolting Grouse nonsense. Even with their Sunday clothes on I can still tell one from the other.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00048"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘So is that your standard tipple?’ I ask her, amused at her extravagance.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00049"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘Only when there’s someone else to do it for me, or if I know I’m really going to be hitting the sauce. It dehydrates and rehydrates me simultaneously. I never get a bad head, just a good night’s sleep.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00050"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("I’m completely sold on hot toddies and begin wolfing down the wine, briefly scanning the girls as I swallow. Coo seems to be having most success with the Traverse dream-boat. The rest sulk round them, having one of their little joint-rolling conferences. I don’t think I’ve ever met any of them when they’ve been straight. Mind you, I’m hardly one to talk. I’m only ever straight at work. Usually! Turning back ")]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("to Hope I take a long sniff of her drink and go mmmmm.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00051"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘Finish that red muck and have one if you wish. Don’t let the rest of them near it though or I’ll end up on the red muck too.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00052"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("I’m flattered that she seems to have singled me out like this and feel a need to disassociate myself from the rest of them. They suddenly seem so childish, superficial.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00053"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘So you’re having some accommodation trouble I gather?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00054"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("Not wanting to sound like a dosser after Shirley’s ‘smelly place’ comment I play it down.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00055"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘I’d like a bigger place but they all want a deposit and a month’s rent in advance and I resent handing "), _c('i', [_vm._v("£")]), _vm._v("1200 over to some horrid little Jew before I even spend a night there.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00056"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("Oh shit, the anti-Semitic lapse was maybe a bit much. Hope is smiling and seems to have appreciated it though.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00057"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘Indeed.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00058"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘Besides, I spend so much time at work I never have time to look at anywhere.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00059"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘What’s your line of work?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00060"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("God, how embarrassing.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00061"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘I manage a bookshop near Stockbridge. Not really what I intended to do with my MA in Fine Arts but you just can’t get funding these days.’ Does it sound like I’m hustling her? Fuck, I’m just being honest.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00062"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘Surely the Arts Council could help you out? What about a Creative Scotland Award?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00063"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘Erm … oh yes. I suppose I could try that.’ Shit, shit, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("shit. I got them to send me a form out to apply last year but I couldn’t be arsed to fill it in. She’ll think I don’t know what I’m talking about now.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00064"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("Supping her toddie, she glares at me as if she’s trying to suss me out. Just as I convince myself she’s realised what a twat I am however, she says very matter of factly, ‘There’s bags of room in my flat. I’m not out of my mind with loneliness as Angus seems to think but you’re welcome to stay while you look for somewhere. It’s Northumberland Street.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00065"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("Northumberland Street! Isn’t it that gorgeous Georgian street that all the queens stay in? I’m instantly fantasising about leaving my shithole in Haymarket behind, along with two months’ unpaid rent, a kicked-in wardrobe and some extremely dodgy downloads on the flat computer’s internet history. I knew there must be a reason I pulled the ambulance stunt to get up here tonight. You never see cabs in Whitson. Nobody can afford them. God, I’m sitting gouching without having responded to Hope’s offer.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00066"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘Seriously, you wouldn’t mind?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00067"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("She laughs as if I’m joking. ‘What’s to mind? You’re not a sociopath are you? Angus can vouch for you, can’t you Angus?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00068"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("Shirley tries to focus his attention away from Traverse-boy. Jesus, don’t they get bored being so lecherously queeny all the time? He points at the blood orange carton, not understanding.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00070"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘No dear, I’m just wondering if Martin here would be likely to run off with the family silver.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00071"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘I’d let him. Silver’s just so passé. Make not bad ashtrays I suppose.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00072"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("Jesus, do people really have family silver? I’ll be lucky to get a sixteen-piece catalogue special with two chipped saucers and a plate missing when mum pegs out.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00073"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("Angus gives me the thumbs up regardless and immediately turns his attention back to Traverse-boy who I’ve decided looks like a young Christopher Walken.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00074"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("Hope grabs my hand and shakes it till I hear the bones crack.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00075"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘See how we get on anyway. Better than throwing money at a horrid little Jew. I’ve known a few myself.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00076"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("I shake back enthusiastically, consciously more firmly than my usual flaccid-penis-in-the-palm thing.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00077"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘That’s great, honestly, great.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00078"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("People are so stupid. They trust implicitly anyone who shows the slightest interest in them. It’s loneliness I suppose. Other people can’t seem to be comfortable with their own company the way I can, pathetic really. I can make myself like Hope though. I can make myself like anyone.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("2")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00079"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("The following day, I go for a few swifties in the New Town after work for my nerves then make my way down to Northumberland Street, to see the flat. As I try to work out ")]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("the house numbers, I see Hope struggling towards me, two Thresher bags clanking from each arm.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00080"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘I thought I should rejuvenate my drinks cabinet if I’m going to have company. Please don’t say you’re a whisky puritan like myself, I’ve rather splashed out on lesser things.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00081"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("As I wrestle a couple of bags off her, she begins making her way up the steps to one of the houses. It’s like a fucking foreign embassy. Then we’re on the way up this plush and seemingly endless stair. For a second I think she owns the whole thing. Fuck, these New Town places are only three floors but they seem infinitely higher than normal stairs. By the time we finally reach the top landing, I’m knackered. Hope smiles at my wheezing, looking decidedly unexerted.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00082"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘I only keep this place on for the exercise. It’s either that or starving myself. I can’t abide overweight people.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00083"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("The front door opens onto a very long, polished-floored hall. Old film posters are pasted to the walls like they used to be outside cinema two at the Filmhouse. I wonder who stole whose idea. Some of them would be worth a fortune. "), _c('i', [_vm._v("The Wizard of Oz")]), _vm._v(" looks like an original, "), _c('i', [_vm._v("Lolita, The Servant,")]), _vm._v(" "), _c('i', [_vm._v("The Sweet Smell of Success")]), _vm._v(" – they all look old. Pasted to the bloody walls though, worthless.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00084"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘This is absolutely fab. Did you do it yourself?’ I ask her, gesturing to a poster for the original "), _c('i', [_vm._v("Desperate Hours")]), _vm._v(". God, Bogie was such a man.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00085"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘Good God, no. I don’t have the patience. They were ")]), _c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("my husband’s babies. Completely movie-mad he was. We saw a lot of them together. They remind me of him, in a good way.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00086"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("All over the ceiling as well. God, it’s so cool. I’m trying to see how many I recognise as she leads me to this enormous kitchen. In the centre is a huge, cast-iron cooking range, overhung by dozens of stainless steel utensils. Honestly, every cooking implement (and some that look like they came out of Guantánamo Bay) you could ever dream of. At the top of the room, by the window, is a massive china sink, like the kind you used to get in art classes and a gorgeous chunky oak breakfast table. It’s like a bloody hotel kitchen. I think of the windowless boxroom in my current flat with ochre grease a centimetre deep on the walls. The walls in here are a fresh-looking Habitat green with a stunning abstract-print linoleum floor. Opening the vast fridge door, Hope begins transferring bottles from her bags.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00087"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("‘What’s your poison? Wine, beer, champagne? There’s spirits in the other room if you’d prefer.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00088"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("‘Anything, I don’t mind.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00089"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("Hope extracts the Moët with a flourish.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00090"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("‘How about this to whet our whistles? Carry it round with us as I show you the place.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00091"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("Popping it open she hands me a glass with a bowl the size of a grapefruit and pours us both one.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00092"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("‘To you and your kindness.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00094"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("She pulls a face and switches off the kitchen light.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00095"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘Spare me the sentiment, dear, please, it lulls one into a terribly false sense of security.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00096"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("First on the right is this enormous bedroom – big brass double bed, polished floors with a couple of extremely expensive-looking rugs, ornate lead fireplace, with a view right down towards Stockbridge and into the houses of all these rich, lucky bastards. A lovely mahogany wardrobe and chest of drawers; massive old pirate’s chest. This must be Hope’s room, absolutely exquisite.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00097"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("‘What do you think then? Will it do until you find somewhere else? Don’t worry about money. Cook me the odd spaghetti carbonara if you must.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00098"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("I’m utterly aghast, already imagining the reactions of the people I’m going to invite here, the ones who try to make me feel inadequate because I don’t have my own place. Fuck them and their mortgages.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00099"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("Hope seems so keen for me to stay, and for free. There will most definitely be a catch but I’m damned if I’m going to worry about that before it makes itself apparent. Could I finally be getting a break?")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00100"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("There are another three bedrooms, all immaculate, like mine, and Hope’s, which is packed to the gunnels with books, antiques and boxes looking for a home. You can barely make out her bed amidst the intense camouflage of clutter. Our rooms are at opposite ends of the hall, however it is hers, rather than my own which is conveniently next to the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("main door. We have a bathroom each, both with gloriously theatrical dressing-room bulbs round the mirrors, perfect for blackheads. It’s like bloody Malmaison.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00101"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("Eventually we retire to the living room, which is so wonderfully chilled-out it’s unreal. Again, big, chunky armchairs with ethnic-looking throws over them, massive fireplace, antiques absolutely everywhere, loads of plants.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00102"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("Hope puts the Moët on the table in front of the fire, switches on an art deco lamp in the corner of the room and tells me to make myself at home. I already am – totally.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00103"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("We seem to become embroiled in this intense conversation as soon as we sit down. There’s none of that ridiculous small talk that Edinburgh people usually use to keep people at a distance till they’ve decided what to dislike about them. Hope appears to have angles on everything that I’d never even contemplated before and seems able to make any topic interesting. She sells all these wild concepts to me and is encouraging enough to make me think up a few of my own. It’s so refreshing. The Scots used to be renowned for their love of a good argument. Now they just bottle it up and go daft. As we finish off the champagne, having smoked a few joints, I start going on about the Holocaust.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00104"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("‘It was more like a revolution if you ask me. Honestly, if there was a major revolution in Britain tomorrow the targets would be the same. All these wee enclosed, self-perpetuating groups of wealthy people – the Jews, the black market, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("Freemasons, homosexuals, the aristocracy. You know? They’re all we’re-all-right-Jack types?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00105"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("Whilst I realise I shouldn’t really be advocating the gassing of gays I feel like I’ve suddenly understood what it was actually all about. Like I’ve just realised how we colonise things – bars, professions, streets, councils – and can be protesting for the right to be accepted one minute and watching someone’s grandad take a dump through a hole in a wall the next. I don’t want to be gay, I never have. I hate gays and that contempt they have for everyone else. I see it in myself and I hate that too.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00106"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("In the midst of regaling Hope with my new homophobic philosophy I start to panic that I’m going too far or that I’m getting a bit anything-you-can-think-I-can-think-sicker. I’m pleased with the bit about recognising it in myself though. It makes me seem quite sorted I think. Hope refills our glasses with two huge measures of a seemingly precious bottle of Glencoe though, so she must have appreciated it.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00107"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("‘Oh, I’m a great one for extremes myself, my dear. The middle ground has always bored me silly. Someone once said I should set up a fascio-communist alliance. My politics sort of dangles somewhere along the Bering Straits.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00108"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("Although her comment is intended to put me at ease, it unnerves me and I begin to worry about her being more intelligent than me, thinking I’m an arse. Why am I having this sudden downer when I had coke-like confidence a minute ago? To overcome my negative thoughts I study the stack of ")]), _c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("CDs by the fireplace, mainly classical, bloody boxed sets – Mozart complete piano sonatas, the whole "), _c('i', [_vm._v("Ring")]), _vm._v(", loads of Bach and baroque stuff which I love, musicals, hundreds of film soundtracks.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00109"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("Hope tells me to put something on and I start to panic again as I’m certain I’ll pick the one she hates, the one she’s ashamed of. I’m taking too long so I plump for Debussy and start going on about him dying of fright when he heard the noises of battle coming towards him. Then I realise I’m taking the word of a music teacher, fifteen years ago, who probably made it up in a fruitless attempt to make the pupils more interested. Change the subject, quick!")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00110"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘I’ve not noticed a television in the flat. Are you a nonbeliever?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00111"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘Can’t stand it. The real opium of the masses. I can’t tell you how many good friends I’ve seen wither to death in front of the box. It’s worse than cancer.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00112"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("Oh well, there goes "), _c('i', [_vm._v("Newsnight Review")]), _vm._v(" and "), _c('i', [_vm._v("Big Brother.")])])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00113"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘It can be terribly manipulative, I suppose.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00114"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘I’ll say. Wasn’t it originally supposed to be educational and impartial. Bloody propaganda! If I want to learn about something I’ll go to a library and make up my own mind, thank you.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00115"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘Not get your opinions prescribed to you by multinationals,’ I manage to slur out, replenishing my confidence somewhat.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00116"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("‘Precisely!’ and she clinks her glass against mine.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00118"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("My sense of wellbeing gathers momentum again as we begin joking about the things that make life worth living. It’s amazing how many queer wee things we have in common – Bob Fosse musicals; DH Lawrence; really fishy seafood; the cult of Terry Wogan (and she was snooty about TV?); the Q&A in the Saturday "), _c('i', [_vm._v("Guardian")]), _vm._v(" being the best bit; sitting amongst cows and the smells of the London Underground; tar; carbolic soap; baked potato shops; and these little white bits you cough up sometimes. Jesus, and I thought I was the only one.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00119"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("Then we start on our dislikes. We resolutely agree on mobile phones; cars; media witchhunts; people who tell you to cheer up just because you’re not grinning inanely; the tragedy of bad smells during beautiful moments; snoring; any form of audible breathing; mothers who don’t need to work but do (hi mum!); the Middle East (both sides); and people who break wind in public.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00120"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("Then Hope doesn’t respond to my ‘women who have abortions because they want a life’ (hi again, mum, I didn’t want a brother anyway). If that doesn’t make me paranoid enough, she then comes out with ‘confidence tricksters’ and ‘people who rip-off the Health Service’ in quick succession.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00121"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("I don’t know how long I sit with a stupid look on my face before managing a measly, ‘people who go on about their sun tans’ (Hope and myself are both peely-wally and interesting) and the fact that the "), _c('i', [_vm._v("Daily Record")]), _vm._v(" is the biggest-selling newspaper in Scotland. I realise how crap they are as ")]), _c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("soon as I’ve said them but it’s too late now anyway. These little rushes of unpleasantness are starting to get the better of me and I want to go. She can’t see me puking in the toilet before I even move in.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00122"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("Wolfing down the remainder of my whisky, and stifling a subsequent boak, I say I’ll have to go, work in the morning, all that shit. Hope welcomes me to stay the night but I want back to my moisturiser and my Ribena and just that pile of rubbish I call home. Once I’ve moved it here, this will be home. That is the nature of rubbish.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00123"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("As I won’t be able to flit for a couple of days (the landlord’s always snooping around for the rent on Wednesdays and Thursdays) I give her my work number in case she changes her mind. I’m only thinking about the good bits by the time I get in the taxi. Northumberland Street, you cunt!")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("3")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00124"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("I busy myself for the next couple of nights hassling the local grocers for cardboard boxes and savagely disposing of a lot of my belongings in the name of a lighter-travelling existence. Having to work until six both nights doesn’t help. I have loads of annual leave to take but it’s not cost effective. Besides, I’m saving it up for a big blow-out, maybe a cruise.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00125"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("Generally, the majority of my working days are spent constructively anyway, i.e. not working. Hope and I have a ")]), _c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("few long phone calls at my boss’s expense. It’s good to have someone intelligent to talk to for a change.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00126"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("I’m lucky if I get three hours’ sleep on the Thursday, my last night in Shitsville, as I’m thinking about that gorgeous flat and the people I’m going to show it to and potentially good times with Hope. Life does smile on me sometimes. I must take advantage of it this time.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00127"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("Leaving for work the next morning for the last time is glorious. At the side of the bulging wheelie bin, my excess baggage lies strewn for the binmen along Haymarket Terrace, like the staff of Number Ten bidding farewell to an outgoing Prime Minister. Though I leave ten minutes after I should have opened up I take my time to gaze at the shit-stained road for hopefully the second last time. Who buys secondhand books at ten in the morning anyway? I’ve been running the shop on my own since my boss retired three months ago. He just pays the bills now.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00128"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("Cutting down Palmerston Place I walk along the Water of Leith. The smell of rotting vegetation is as refreshing to me as sea air. As I pass under the Dean Bridge, I recall a fuck I had down here with an old wino in my early teens. He could only summon a semi, but it was huge. I had sparse pubes at the time, which really drove him wild, but he stank of rotting liver.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00129"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("An old bloke walks past with his dog, jolting me out of my thoughts with a ridiculous, ‘Cheer up, it’s not the end of the world.’ Christ, we were just talking about that the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_vm._v("other night. People do actually still say it. I give the old tosser a smile anyway. He has a complexion like an uncooked beef sausage.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00130"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_vm._v("It’s 10.25 by the time I get to the shop. In the unlikely event that Callum the owner’s phoned to check I’m in on time, I’ll just say I forgot to switch the answering machine off. Another plus of not having a mobile phone. No messages though, no calls and no customers for most of the morning. Leisurely speeding myself up with black coffee, I listen to Classic FM and throw myself into the "), _c('i', [_vm._v("Scotsman")]), _vm._v(" crossword. Sometimes I really like routine.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00131"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_vm._v("A Goth-looking lassie comes in about 11.15 and tries to sell me a bag of John Mortimer. How is there so much fucking John Mortimer, John Galsworthy and Raymond Chandler in the world? I think they breed with each other on the shelves at Barnardo’s. Having regaled the lassie with my observation, she looks suitably embarrassed, then slopes back to Transylvania.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00132"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_vm._v("Occasionally in this shop I’ll get offered a little gem but generally it’s scruffy twenty-somethings who sell me course books, get used to the extra money then bring in their film books, then the Penguin Classics till eventually it’s the spanking new never-read book club editions and they come in with tears in their eyes. I take books off these student bastards I know I can sell for a couple of hundred pounds, get them to sign for enough money for a sixteenth, then stick a two or three in front of the "), _c('i', [_vm._v("£")]), _vm._v("7.50 when they leave – everybody’s ")]), _c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("happy! Stewart only pays me "), _c('i', [_vm._v("£")]), _vm._v("120 a week, after tax. I’ll be saving "), _c('i', [_vm._v("£")]), _vm._v("45 a week on the flat now so that can go straight in my Instant Access Savings Account. The rest of my money usually gets tied up in debts I haven’t been able to dump and my blow. For entertainment I usually aim to fiddle about £50 a day which is piss easy via a subtle combination of over-charging, under-ringing, altering figures and private sales. The shop only takes about "), _c('i', [_vm._v("£")]), _vm._v("150 a day but Callum hasn’t checked the accounts in ages. The cancer will finish him off in a few months anyway. He’s not going to waste his time book-keeping now.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00133"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("By closing-up time I’m pretty excited about the move but starting to feel a bit edgy about cohabiting with a woman I’ve only known for three days who’s older than my mother. I don’t want to end up like some Tennessee Williams toy boy. Do women her age still want sex? Surely not. Is it obvious enough that I’m gay? She is all right though, I’m sure. I know I was pissed but we’ve been fine on the phone since and we have a laugh together. Besides, I read somewhere that mothers are supposed to be the new fashion accessory.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00004"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("4")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00134"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("One taxi journey is enough to transfer the few worldly belongings I haven’t binned to my new street. The three boxes of junk and expandable case full of clothes take only two treks up and down the stairs. A previous entourage of books and ")]), _c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("records were sold long ago in less flush days. My current occupation is a symptom of this.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00135"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("Hope flutters around as I feather my new nest with my minimalist belongings, trilling along to a Kurt Weill CD. Adding a few postcards and random drapings of white muslin, I roll a joint. Unwinding with the first few puffs I take it through to Hope with a bottle of Bowmore I got her on the way back from work.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00136"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘For me, darling? How sweet.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00137"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Just to say thanks, you know, for letting me stay. I’ll find my own place as soon as I can.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00138"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘If you’d rather be on your own, that’s fine. You’re welcome here though, no rush. No more presents though, ok?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00139"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("She hands me back the spliff as I follow her through to the living room. I’m expecting a whisky but she puts the Bowmore in a cupboard and squeezes past me into the hall again.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00140"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘I’m going to be away for the night. You don’t mind, do you? You won’t be scared?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00141"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Erm, no, that’s fine,’ I stammer, slightly taken aback. ‘Going anywhere exotic?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00142"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("She slings a shawl dramatically around her shoulders and grimaces at me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00143"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("‘Not exactly, well not unless your idea of exotica is line dancing in Loanhead.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00144"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("I laugh too forcefully.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00146"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘Oh I know, dear. I went there with some friends about three months ago though and I’m completely hooked. Pathetic, isn’t it. Anyway, it’s one of the few places I can go and still feel faintly glamorous.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00147"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("Biting back a mumble of patronising clichés about being good for her age, I settle for a simple, ‘I know the feeling.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00148"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("Then the front door’s open and she’s rushing out excitedly.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00149"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("‘Try to enjoy yourself and if you do burn the house down, make sure it looks like an accident – insurance, you know? I should be back tomorrow evening sometime. Be a good boy,’ and she pats my cheek and launches down the stairs.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00150"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("I feel quite stunned for some reason as I wave over the bannister at her. As she gets to the bottom she shouts up, ‘I go to the occasional rave as well,’ then I hear the stair door slam. It’s more than I do.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00151"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("Going back into the flat I stand and stare along the huge empty hall. My huge empty hall. Fuck two years of celibacy. I’m bringing a man back here tonight.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("5")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00152"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("Time seems to pass so quickly as you get older. It seems as if the South Bank Show’s on every night of the week. My system never gets time to recover between drinking bouts. What the hell, it’s predominantly wine I drink, which is good for you anyway. Drinking is preferable to eating. The choice ")]), _c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("between two bottles of claret or a meal is a simple one. Eating’s time consuming and makes you look so bloody bad. I’m lucky if I have one proper meal a week but I still look fat. I can feel my ribs through my jumper but I’m terribly podgy about the abdomen.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00153"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("Going to my enormous, gorgeous room, I stick Garbage on, uncork the bottle of red wine I bought myself and roll a massive spliff. Striding about, knocking back the drink, I look at the view down to Dublin Street and across towards Stockbridge, into the lives of all these rich fuckers and I think here I come, you bastards, here I fucking come.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00154"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("I sit down on the bed and begin fantasising about all the different people I’m going to bring back here. What their reactions will be. Then I have a prolonged dwam about slapping this little chicken I have my eye on about the place and almost get a hard-on. When I come to, it’s 9.45, and the wine’s nearly finished. Two and a half hours have vanished. This happens a lot these days. I go into myself and can’t find the way out.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00155"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("Forcing myself under the shower, it feels fantastic after the dirty, fibreglass tub I’ve been subjected to for the past three years. Feeling suitably invigorated I study my nakedness in the bathroom’s full-length mirror. Jesus, my belly gets bigger every time I look at it. Maybe I should shave my pubes again. It might help me feel hornier.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00156"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("Despite my liberating flit from Haymarket I feel ")]), _c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("strangely drawn to my old local. Faggots have been slowly streaming into it over the past few years and it’s now more or less a gay bar but with the odd hairy arsed workman. The other guys remain unconvinced and refuse to go there with me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00157"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("I want someone with me tonight though, an accomplice, someone to do all the talking while I stalk my prey. Jesus, listen to me. Who am I kidding? I’m beginning to think I’m completely unshaggable. Some speed might help, but it always makes me psychotic and I feel like topping myself for about a week afterwards. It’s just the physical act of snorting it I like. It goes pear-shaped after that.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00158"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("Once I’m outside and fully conscious of where I am, I see sense about my Haymarket idea, and allow my feet to drag me easterly, to the Phoenix. As I swing into a room full of vodka-breathed people it seems not a bad decision. I always see someone I know in here, I think, a second before seeing Simon, a guy I know from Sainsbury’s Central who’s usually good for a bit of toot. Standing at the bar with him I begin to think my life is either charmed or I am psychic.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00159"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("Simon gets me a double Black Label Smirnoff and Diet Coke. It’s so cheap in here it’s untrue. We go up the steps, sit looking down on the bar and I painlessly score a gram off him. There is a guy at the juke box with his dog, acned ugly bastard but wearing football shorts which I love. There’s something about that flimsy layer of fibre between ")]), _c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("me and a cock. My ultimate fantasy is to be at a football match, standing beside some wee kids and their dad, someone like Duncan Ferguson getting tripped-up in front of us and his three-piece falling out the bottom of his shorts. I saw a photo of that very phenomenon in a magazine a few years ago but I thought of it first. I made Duncan’s balls fall out.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00160"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("Simon starts telling me about his friend in the Western with pneumonia, being on his last legs. The last time I saw the guy was about two months ago in the New Town. He had on a cropped t-shirt to show off his suspicious sarcomas. He works for an AIDS charity as well. Mind you, everyone I know that works for an AIDS charity is HIV positive. It doesn’t do much to reinforce my faith in safe sex.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00161"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("Was I sitting gouching when he was telling me about his pal dying? Oh God, he’s talking about Joy Division now. Simon always seems to bring every conversation round to bloody Joy Division or bands he thinks are trying to sound like Joy Division. The singer died about 20 years ago didn’t he? They were crap anyway.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00162"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("‘Did I tell you about the time I saw them support the Buzzcocks at the Odeon?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00163"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("‘I think you have, yeah, you definitely have.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00164"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("About a thousand times. I start checking out the bar for possible means of escape from misery-guts as there’s no way I’m spending my night talking about John Peel and ")]), _c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("the cowie. The guy in the football shorts gives me a thin smile as I catch his eye. There’s something really horny about ugly guys. They look like they’re game for anything, and they’re usually so grateful you’re taking them on they go mad for it. I’ve seen him before a few times but I can’t remember where.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00165"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("I tell Simon I’m going to the cigarette machine and get up. The guy is still clocking me, blatantly, I love that. Pretending to put money in the machine, I push the button for Silk Cut. It rumbles, I slap it and walk back up to the table.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00166"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("‘They’ve run out, I’m just going over to the chippie.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00167"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("Simon has started chatting to a guy with fluorescent orange hair and merely nods in acknowledgement without looking round.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00168"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("Walking out the pub I sense the guy with the shorts following me. My legs go a bit shaky, it’s so fucking long since I’ve done anything like this. He comes out behind me, just like I expect him to. Joe Orton was right. I don’t know how you know, you just do. This surge of bravado just comes from nowhere. When I pretend to go back into the pub he blocks my way, grinning.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00169"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("‘You don’t really want to go back in there, do you?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00170"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("‘What would you suggest like?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00171"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("He shrugs his shoulders and we both walk back towards my new pad with his mutt. The last two days have had a dream-like simplicity about them.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00172"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  })]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("6")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00173"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("His snoring wakes me in the middle of the night. I’m horrified to find him beside me and even more horrified to find his smelly dog squeezed in between us. How could a bottle of red wine and a vodka be so kind on the features of someone so grotesque? The snoring makes him doubly unappealing. I stare at him for a minute with an uneasy mix of anger and morbid fascination till the sound of his honking drives me out of the room. My rage is then propounded by a recollection of me not being able to get a proper hard-on when he tried to suck me off. I want him out of here, I wish he was dead. Did he say he was from Haymarket? That’s where I’ve seen him before. Thank fuck I’m away from there now.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00174"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("Stomping through to the living room, I attempt to roll a joint but my hands are shaking because I’m so annoyed. Just be assertive, I tell myself. Striding back through to the bedroom, I stand beside the bed looking down at him.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00175"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("‘Hey, hey pal. Wake up.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00176"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("He just lies snoring. I give him a gentle shake. ‘Hey, come on, you’ll have to go.’ Still no response so I shake him more firmly. Surely that should have woken him up. Perhaps he’s pretending to be asleep. I jostle him until he rolls onto his back. Still the awful noise continues. The anger is pumping adrenaline through my body. Lifting the quilt up, I grab his feet and pull him off the bed. As he thuds onto the floor ")]), _c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("his head cracks on the floorboards. Shit, I panic but the pain wakes him and he fumbles blindly for the duvet, wondering what’s going on.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00177"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘I’m sorry but I’d rather you went home. Nothing personal you know. I just need some time on my own.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00178"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("He seems confused but ok about it all and starts stumbling into his ridiculous outfit again. Not knowing what to say, I go back through to my joint as the decisive action has curtailed my trembling. After a couple of minutes he comes through to say goodbye.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00179"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("As I open the front door, I allow him to kiss me, just so he’ll go away.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00180"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Do you live here now then?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00181"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("Though I don’t want him to know I do, the pose is almost irresistible. Compromising I give him a what-do-you-think shrug.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00182"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("‘Probably bump into you again sometime,’ I say as I shut the door, knowing that life can sometimes be that cruel. Dammit, and the Phoenix is so convenient now.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00183"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("Stripping the covers off my bed I stuff them in the washing machine. Remembering the joint, I take it through to my bedroom and start rummaging through one of my unpacked boxes of stuff. Why have I let that bastard get to me? I’m on a real downer now because I’ve sacrificed two years of celibacy for someone so inconsequential.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00184"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("Hyper-alert through rage and remnants of the speed, I thumb through photos of myself as a teenager and think ")]), _c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("what a fat geek I was. I find a ticket for BB King at the Playhouse from years ago and remember my hot date that night with a computer salesman I met in a toilet, who said he was going to take me away from it all. We snogged in the middle row. He told me I made him feel like James Dean. That was the last time I saw him. I hate BB King. My 1992 diary keeps coming to the top of the pile of junk but I’m trying to ignore it as diary-reading makes me feel like such an old fag. Perhaps one random page won’t hurt.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_c('div', {
    staticClass: "block extract",
    attrs: {
      "id": "rw-block-extract_127430-00001"
    }
  }, [_c('p', {
    staticClass: "fp"
  }, [_c('i', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Monday 7 May 1992")])])]), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Mum lost her job. Wept a lot. Felt panicky and angry all day.")]), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('i', [_vm._v("Tuesday 8 May 1992 ")])])]), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Felt depressed in the morning but was unemotional by bedtime.")]), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('i', [_vm._v("Wednesday 9 May 1992 ")])])]), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Felt neither here nor there in morning. Threw a wobbly in a restaurant. Unemotional for the rest of the day.")]), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('i', [_vm._v("Thursday 10 May 1992 ")])])]), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Watched "), _c('i', [_vm._v("Taxi Driver")]), _vm._v(". Felt mildly paranoid. Felt OK at night.")]), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('i', [_vm._v("Friday 11 May 1992")])]), _c('i')]), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Felt fine all day. Couldn’t sleep.")]), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('i', [_vm._v("Saturday 12 May 1992")])]), _c('i')]), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Felt bad when I woke up. Didn’t get Napier job. Thought when I was happy it was perhaps only mania. Felt better at night but couldn’t sleep.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("Jesus, have I always been such a sad bastard? I go back to bed but can hardly think for thinking about it.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("7")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00187"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("Waking up in my new home is rather disorientating and my first thought is that I must have copped with some old pouve or other. Once I’ve opened the shutters (yes, proper shutters, it’s like fucking Paris), got Maria Callas blaring and christened my new toilet it feels significantly more homely. I devote most of the morning to swallowing strong black coffee (proper stuff, natch), smoking joints and nosing round the flat. Hope has some amazing clothes – as if Lena Martell, Quentin Crisp and the cast of a blaxploitation movie maybe shared a wardrobe at some point. Everything smells of her, in a good way.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00188"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("Rummaging through her drawers, I’m intrigued to find out what kind of knickers she might wear. The bland, pastel-shaded Marks and Spencer briefs sort of disappoint me but are at least better than the shoulder-length passion-killers mum wears.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00189"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("Noticing a "), _c('i', [_vm._v("Miller’s Antiques Guide")]), _vm._v(" in the tightly crammed bookcase I wrench it out and begin thumbing through it. Maybe I can identify some of the things she has stashed in here. It’s tiresome at first having to negotiate the lopsided weight of the flimsy pages. As I squint at the tiny print of the index and slowly begin to find things though, I start to really get into it. Hours pass as I study dishes, ornaments, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("sideboards, prints, totting up figures, not with any master plan in mind, just because I’m enjoying teaching myself about it all.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00190"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("By teatime I’m bored with it and exhausted by my own enthusiasm. Feeling listless and strangely alone I’m back in full-fledged sad bastard mode again in no time at all. When Hope’s not back by seven I feel so frustrated I have to go for a lie down. I want to go out somewhere where there’s no faggots, just for a change. Drawing a blank on suitable ideas I watch light dancing on the ceiling from the cars outside till I finally hear the door being unlocked. It’s half eight. Hope drifts in singing ‘Man, I Feel Like a Woman’. Jumping out of bed I rush into the hall to greet her like a dog that’s been on its own too long. She does a bit of her line dancing for me and I’m so pleased to see another human being again, it seems good.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00191"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("‘Oh it’s trite but I love it. Don’t you get like that sometimes?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00192"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("She hangs up her cape and I follow her through to the living room.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00193"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("‘No major disasters? No urban insurrection in Dublin Street? My God, this place looks unnervingly pristine, my dear. Was it a wild party or are you a Virgo?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00194"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("‘Just a Virgo, I’m afraid. I’m very anal about dust.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00195"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("She feigns horror.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00196"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("‘I’ll try to be liberal about it, darling, but I’m allergic to dust myself. Who am I to make spiders homeless?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00198"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("As she floats around the room, animated, I think how full of life she is and how empty of it I am. I think of my own mother – defeated, bowed and living for the bingo. Maybe energy is genetic. Hope tells me she has tickets for a whisky tasting at Waterstone’s and asks if I want to go with her. It sounds just about right. Maybe some of her will rub off on me.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("8")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00199"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("The tasting is downstairs at the East End Waterstone’s. A red-faced wag with a bushy beard describes each malt with such affection and desire that I almost manage to convince myself that I’m not only here for the beer. The really peaty ones are absolutely divine. My first two have me that safe, glowy way. Hope is circulating and seems to know everyone intimately. I’ve still no idea what her background is or where all the money comes from. It’s too soon to ask her outright.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00200"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("A few of the staff I know through Shirley are buzzing around but I’m in one of my shy moods, so just stand in a growing daze, tripping-out over the whisky. My favourite is Isle of Jura because it smells like poppers and takes me from gloriously glowy to borderline pissed so beautifully. As I lean against one of the tables, a heavily made-up creature of indeterminate gender gestures to two measures at my side and stammers,")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00201"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("‘Pleashe … away … I’m fucking guttered.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00203"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("Knowing that two more will probably push me over the edge I sniff both and knock them back. Jesus, whisky makes me feel really straight. It’s such a manly drink.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00204"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("By the time Hope gets round to me, queasiness is making the thought of a joint and an armchair very attractive. Arm-in-arm with the man who gave the talk, she introduces me as her flatmate. Giving my hand a limp, clammy shake he begins quizzing me about what I do, where I come from, what I think of Edinburgh, how I know Hope, which I’m not really up to lying about. The way he launches at me and the intense eye contact suggest he’s quite taken by me but he has terrible halitosis and I have to turn my head when he speaks to me. Hope observes with a worryingly conniving look. I’m starting to wish I’d stayed in. Why is it always the ugly blokes who go for me? If once, just once, a little "), _c('i', [_vm._v("Death in Venice")]), _vm._v(" chicken would return my glance, but no, it’s always those seedy, cruisey types who don’t wash their genitals very often. Why can’t I force myself to like people? I don’t really like anyone, particularly myself.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00205"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("Hope though, I do like, but I don’t want to be here. I always feel like a nonce unless I’m around people who seem less self-assured than myself. Oh God, Hope has just catapulted herself into a circle of luvvies and embraced everyone. The racket of their squawking and the fanfare of own trumpets being blown is grating on me. Now she’s wittering away to the trannie person that gave me its drinks, their faces almost touching as they converse. The ")]), _c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("spectacle upsets me somehow. What am I thinking? Why do I suddenly feel jealous about some old woman? I’m sick of this.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00206"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("Barging up to Hope I tell her I’m leaving, I don’t feel well. Her eyes try to speak to me out of the jumble of sycophants. Standing like a prick for a few minutes, expecting her to come over, she doesn’t, so I make for the exit.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00207"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("Walking out onto Princes Street, I feel like a Christmas puppy in March. The cemetery in Waterloo Place blinks seductively at me but I feel like I don’t want that any more. I don’t know what I want.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00208"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("The walk back to the flat does nothing to lift a feeling of growing doom. I can’t even be bothered to roll a joint when I get in. Besides, my chest is fucked because the blow at the moment is full of plastic. Home by nine on a Saturday night. It’s fucking shocking. Lying fully dressed on the bed I listen to little cracks of noise outside. Am I destined to spend the rest of my life watching car lights on the ceiling? I just want Hope to come home. I’m lonely. I want to know that she likes me. I want to win her over. I’m still sitting waiting at one the next morning. Getting up, I close the shutters, undress, then get back into bed. What a sad bastard.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("9")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00209"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("Despite my early night, the blackened windows allow me to block out the world until well after noon the next day. Hope ")]), _c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("is back as I can hear her singing about the flat. The sound is faintly erotic. It feels like we’re lovers who’ve had a tiff. I worry about myself sometimes. Irritated by my feeling of non-specific mardiness, I force myself out of bed, stretching flamboyantly as I walk over to open the shutters. The streets below are that quiet, restrained Sunday way, as if the houses have all been abandoned. Perhaps I should do some sketches and flog them to the rich bastards that live around here.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00210"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("Then I notice a figure opposite the flat, just standing against the railings. I look away then back to confirm the signal my eyes are sending to my brain. Jesus, surely not. It’s the ugly bloke I brought back the other night, just standing there with that fucking stinky dog. What the fuck is he playing at? What does he want? Hope can’t find out about Friday night, she’ll think I’m such a scab. Fuck, fuck, fuck! Should I ignore him or go and see what he wants? How long has he been there?")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00211"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("Hurriedly struggling into my black Levi’s I look down again. What a fucking weirdo. He’s just standing there smoking. The sight of such an eyesore in my lovely new street offends me. Once I’ve finished dressing I go through to the living room and ask Hope if she needs anything from the shops. She points to a reading room’s-worth of newspapers on the coffee table.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00212"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("‘Most of the papers are there, dear. They keep me entertained until at least Wednesday. There’s cholesterol in the fridge.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00214"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘I’m just after some fresh air, really,’ I blush. God, this is pathetic. How can leading a charmed life be so complicated? I’ve decided to take the guy for a pint as I don’t want us having a barney in the street. We can go round to the New Town. It’s usually full of creeps anyway. Christ, what if the bang on the head yesterday morning’s turned him into a psycho?")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00215"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("He gives me a huge smile and starts walking towards me before I’m even out the stair. Jesus, I can’t even remember his name. Standing stiffly, I allow him to kiss me then push myself out of his embrace and towards the pub.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00216"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘I was just trying to work up the nerve to come up and see you.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00217"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("Hell, no.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00218"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘Look, it’s not convenient for you to come round the house. I live with someone. They were away the other night. We’ll have a drink,’ and I bluster onwards, unable to attempt communication again until I have a pint in front of me. He walks briskly at my side, gibbering away a lot of shite about the New Town, trying to impress me with historical details I couldn’t give a toss about. Why am I even allowing this wanker the courtesy of giving him the brush-off face-to-face?")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00219"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("We sit at the back of the pub, me with a pint, he with a bloody Mary. As his arm sneaks round the back of my shoulders, I push him off.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00220"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("‘Look, pal, the other night, like. Is it OK if we just leave ")]), _c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("it at that? I shouldn’t have taken you back, I’m sorry.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00221"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘Did your mother never tell you not to go with strangers when you were little?’ he smirks, refusing to take me seriously. Gulping back a third of my pint, I try again.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00222"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘Seriously though, you won’t come round again, will you?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00223"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("Leaning back, he takes a contemplative sip of his vodka.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00224"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘Married, are you?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00225"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘No … well, sort of … it’s kind of complicated.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00226"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("He suddenly starts raising his voice. Thankfully it’s empty up the back where we’re sitting.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00227"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘Why do arseholes like you make yourselves available if you’re not prepared to go all the way? Fuck, I must be some sort of magnet to bastards like you. You think you can just fuck me and forget it, eh?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00228"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("Now he’s standing up, hands on hips, having a right queeny fit. What a mess.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00229"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("‘Ok, ok, I’m a bastard, I know. So will you keep away?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00230"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("Vodka and tomato juice are running down my face, my eyes smarting with Worcester Sauce. Making for the bogs, I hear the pub door being yanked open violently. Fuck! Grabbing a toilet roll from one of the cubicles I feel something slimy on my fingers and notice cum squirted across the tissue. Yelling, ‘Bastard!’, I kick the cubicle wall in anger and hear a terrified voice inside squealing, ‘Fucking hell!’. Heading for the exit, I see the barman surrounded by a little ")]), _c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("huddle of poofs, cackling away, watching where we’d been sitting on close-circuit TV behind the bar.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00231"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("‘You don’t want to go upsetting that one,’ someone laughs at me as I leave.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("10")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00232"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("I almost expect him to be standing outside when I leave for work the following morning. Still feeling quite unnerved by yesterday’s performance, I find myself checking behind me as I cut down through Canonmills. Once I’m inside the safety of the shop I castigate myself for my paranoia. As long as I avoid the Phoenix it’ll be fine.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00233"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("Once I’m settled with my coffee and a fag, I start reflecting on the previous night. Hope’s sort of flirting with me, I’m sure she is. She put her feet up on my legs when we were sitting on the settee together. Her heel against my balls gave me a semi. If she noticed she certainly didn’t seem to mind. What the fuck is going on there? I have to sort it out.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00234"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("Every time the shop door goes, I jump. Shirley phones at lunch time to tell me he’s coming round for a visit tonight. I find myself feeling strangely envious that he’s known Hope all his life. I’m thinking about her a lot – about our conversations and her voice and her strong, intelligent face. It’s almost like I miss her. This feeling intensifies as the day progresses, until at three I ring her on the pretence of telling her that her nephew’s coming ")]), _c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("round, knowing they’d made the arrangement prior to him speaking to me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00235"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("‘I’ve just got a few chums round for Canasta, they’re leaving soon.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00236"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("‘Erm … have you spoken to Angus?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00237"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("‘Oh yes, round about eight he said. Anyway, must dash. They’ll be cheating next door.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00238"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("I’m just mumbling, glad to hear her voice.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00239"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("‘OK … erm, yes, well, see you later.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00240"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("‘Martin?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00241"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("‘Yes?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00242"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("‘I missed having you around today. It felt strange …’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00243"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("Although I want to tell her I feel the same, I mumble a bit more then tell her I have to go. God! I bang my head off the desk. What an arsehole I am. I’m bewildered by my own emotions.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("11")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00244"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("In the evening Hope cooks us up a Mexican sensation with tacos and nachos and lots of gorgeous little side dishes which I force myself to eat some of. We drink tequila slammers and at one point the three of us are lying on the carpet, hysterical. Shirley is singing Ethel Merman numbers to himself, obscured by the table. As I roll onto my side to get up, my eyes meet Hope’s and stay there for a few seconds. Despite a terrific urge to kiss her, I feel my face starting to flush and stand up.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00246"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_41"
    }
  }, [_vm._v("‘I almost thought you were going to kiss me, there,’ she says, half-joking, half-serious. Laughing the comment off as ridiculous, I embroil myself in the rolling of a joint.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00247"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_41"
    }
  }, [_vm._v("Shirley and Hope talk a lot about her husband and I insist she gets some photos out. He is a tall, elegant looking man, chiselled-bone structure, but despite his acute angular look there’s a gentle excitement in his eyes. Hope only shows me one wedding photo and shields her face in embarrassment until it’s put away. They were married in a registry office in the sixties, which I think is quite cool. Hope is wearing a trouser suit, like a man’s pinstripe, tailored and tapered at the waist for a woman. Her hair is short and her face is radiant and full of mischief. It’s almost as if someone has cut a photo out of last month’s "), _c('i', [_vm._v("Cosmo")]), _vm._v(" and pasted it on. Apparently, her family thought she was a lesbian prior to her wedding. The suit, Savile Row, was a stab at them.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00248"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_41"
    }
  }, [_vm._v("‘You’ve no idea how threatened a lot of people were by the sight of a woman in a trouser suit. I still sometimes wear it for a lark.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00249"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_41"
    }
  }, [_vm._v("I’m sitting staring at her, as I can blame my fixed gaze on the cannabis. I’d really like to paint her in that suit. When I suggest it to her she seems utterly flattered and insists that I allow her to commission me. Unbelievable, getting paid to do what I feel compelled to do anyway.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00250"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_41"
    }
  }, [_vm._v("Before long, Hope is lying on the settee with her feet on my lap again. As I massage her toes and soles, she writhes around beside me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00252"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_42"
    }
  }, [_vm._v("‘You two seem quite taken with each other,’ Shirley observes as we become increasingly touchy-feely.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00253"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_42"
    }
  }, [_vm._v("Hope leans forward and kisses my cheek.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00254"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_42"
    }
  }, [_vm._v("‘Martin is giving me a new lease of life, not that I was ever as mothballed as you seemed to think. We plan to marry in the Fall.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00255"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_42"
    }
  }, [_vm._v("‘What a riot, having old Dionne here as an uncle. Cool.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00256"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_42"
    }
  }, [_vm._v("‘Watch your tongue lad or you’ll feel my slipper on your arse,’ I scold unamusingly, but we collapse into drug-induced hysterics nonetheless. I’m having my most relaxed time in ages but I’m also aware that it is getting on for midnight and Shirley is making no signs of leaving. I want to be alone with Hope in this state and see what happens. But then she makes hot toddies for us, and more joints are rolled until, at 1.30, Shirley’s eyes start to flicker and he crashes sideways in the armchair. I try shouting over to startle him before he becomes unconscious but he’s already started snoring. Hope swallows down the remainder of her toddie, then pulls herself wearily off me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00257"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_42"
    }
  }, [_vm._v("‘I’m going to follow his example. Give me a knock before you go to work, would you, I’m playing golf at ten,’ then she blows me a kiss and leaves me with the snoring bastard. The moment’s gone now anyway. Perhaps it’s for the best. I’ve probably just got a wee boarding school crush, you know, I shouldn’t necessarily act on it. The sound of Shirley’s snoring is reminding me of that little runt the other night. My ")]), _c('a', {
    attrs: {
      "id": "pb-rw_43"
    }
  }, [_vm._v("eyes wince in recollection of the sting of Worcester Sauce as I retire.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_43"
    }
  }, [_vm._v("12")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00258"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_43"
    }
  }, [_vm._v("Hope gets up before I leave in the morning and makes me a coffee as I shave. She looks gloriously wrecked. Sometimes I judge people’s beauty on how good they’d be to paint. Hope scores highly on this. Shirley has vanished, God knows when. I’m annoyed that he could plausibly have left shortly after we went to bed and I still could have made a move. Made a move, what am I on about? The new day has made me timid again. Perhaps it’s better just to keep it all in my head. You can control situations if you keep them cerebral.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00259"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_43"
    }
  }, [_vm._v("The doorbell goes as I’m about to leave. A woman in her thirties stands behind an eruption of white roses. The lump of envy in my throat disperses when she tells me they’re for Martin. The name on the envelope stuck to the wrapper confirms this but I still look at her as if she’s joking, grab the flowers and in panic shut the door in her face. My immediate instinct is to open it again and apologise, but I’m too agitated. Hope is in the bathroom, thank God. Smuggling the rustling package into my room, I tremblingly tear open the envelope.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00260"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_43"
    }
  }, [_vm._v("‘Forgot to say. You sucked my cock beautifully. Rxxx.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00261"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_43"
    }
  }, [_vm._v("I feel sick, in fact I bring up and swallow a mouthful of coffee. My shoulders become very sore all of a sudden. Fuck ")]), _c('a', {
    attrs: {
      "id": "pb-rw_44"
    }
  }, [_vm._v("fuck fuck. Tearing the remainder of the envelope from the wrapper, I stuff it, with the card, under my mattress. Grabbing one of my Lucien Freud postcards off the wall, I scrawl, ‘Thanks. Last Present, honest!’ regretting it immediately but throw it and the flowers on the telephone table regardless and run out the house. White roses are just so gorgeous. If they’d been tacky red they’d have gone straight in the bin.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00262"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_44"
    }
  }, [_vm._v("Running round to Dublin Street, I hail the first taxi I see. I don’t want anyone following me to the shop. It’s my safe haven.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_44"
    }
  }, [_vm._v("13")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00263"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_44"
    }
  }, [_vm._v("I’m in pieces at work. He’ll be standing outside the flat when I get back tonight, I know he will. I’ve never been violent towards another human being but I’ve done some serious damage to inanimate objects in my time. Who knows how I’d react under pressure? It feels as if I’m being violated. What right does the ugly creature feel he has to hassle me like this? I’m an attractive guy. As if I’d get involved with that. Would I be letting it get to me as much if Hope wasn’t in the equation? The fact is I would. When people try to invade my space and time it really pisses me off. I make my own decisions about if and when I see people and I hate anyone who tries to interfere with that. I’d get the police onto him but I realise I can’t really. It would just bring it out in the open even more; besides, they’d piss themselves laughing.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00265"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_45"
    }
  }, [_vm._v("I’m rude to the few customers we have because I’m so stressed out. At one point I put a ‘back in 10 minutes’ sign on the door and go to the back of the shop for a joint, but this just serves to make me even more tense. Sometimes I think I get no hit from cannabis any more, that I’m completely immune. Having a joint at work always dispels this theory though, as the surroundings really seem to intensify the hit. It also makes time drag something awful.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00266"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_45"
    }
  }, [_vm._v("I’m kinder to the customers after the smoke, and end up nervously raving to them about the books they’re buying. About 2.30 a guy comes in with a large cardboard box. He looks like Harold Shipman. Turns out he’s flogging these extremely rare, immaculate art books – Lucien Freud, Bacon, Kitaj and one on the Scottish Colourists with actual prints by Cadell in it. Books I had no idea even existed. In Italian, mind you, but the sort of people that buy books like these are all cunnilingual anyway. I can tell that parting with them really pains the guy, something about the CSA being on his back. Business is business though and I tell him that my business is slow and hum and haw in my usual way till he’s really desperate. After torturing him like this for a while, I offer thirty quid for the lot and he predictably jumps at it, looking thoroughly sick as he does. I can probably get that for each of them. Entering them in the ledger as indiscriminate ‘Art Books (several)’ I make sure to leave plenty of space between the pound sign and the thirty. When he leaves I stash an amazing book of Egon Schiele plates in my bag at ")]), _c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  }, [_vm._v("the back of the shop, make a coffee and settle down to look through the rest of them, feeling infinitely happier. A few hundred pounds for two minutes’ ham acting. Now I know how Sean Connery feels.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00267"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  }, [_vm._v("I’ve only just started to price them when a woman comes over with a hefty tome on Raeburn that’s been collecting dust since I started here. She spots the Colourists book and asks me how much. I’ve no idea what it’s worth. It’s a fucking antique – could be hundreds, could be thousands. As it’s not even been named in the ledger I hazard a guess at ninety pounds. The woman’s face lights up as she pulls twenty pound notes from her purse and I know I’ve made a huge boo boo. Too late to worry about it now though and it means I’ve made a cool two hundred today including ten pounds on my first sale this morning. As I put the books in a bag for her, she thanks me profusely. The difference between her joy and the anguish of the guy who sold me them is striking. She’s probably his ex-wife and followed him here.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00268"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  }, [_vm._v("Buoyed by my burgeoning wealth I start thinking about holidays. Maybe Hope and I could go away somewhere together. I’ve only been out of Britain twice, to Paris, since I got my passport and it runs out in a couple of years. She’d be good, intelligent company to travel abroad with. She could teach me so much. Perhaps I should suggest it anyway, she’d probably insist on financing the whole trip.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00269"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  }, [_vm._v("About two o’clock a spotty bloke in a donkey jacket ")]), _c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("comes in with a holdall and tells me he has a few Williams first editions to sell. I can’t believe it, ‘Tennessee Williams?’ I confirm. He looks at me blankly. ‘Naw, Raymond.’ I suppose one coup a day is enough.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00270"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("After that, the shop is dead. Not that I mind, as I’ve had a good innings and I’m content to just put my feet up for the rest of the afternoon. Making a coffee I engross myself in my Egon Schiele book. The bell above the shop door tinkles and before I even look up, I get the strange sense that I’m not going to like what I see. First it’s the horrible fucking dog, then the creep, smiling, coming towards me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00271"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("‘Any nice surprises with the postman this morning?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00272"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("I’m dumbstruck. I can’t believe he’s found his way into my other world.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00273"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("‘I’m a hopeless romantic, I just can’t help myself. I hope white is your colour. I’m surrendering to you.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00274"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("I stand up to establish some semblance of power.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00275"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("‘Look pal, I don’t want your flowers and I don’t want you following me about.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00276"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("He looks genuinely offended.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00277"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("‘I’m not following you, doll. I just popped in to see you.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00278"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("‘How did you know where I worked? You must have followed me.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00279"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("He laughs now, as I erupt internally.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00280"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("‘Are you joking? This is where I first met you, remember? I used to bring in piles of uncorrected proofs when I worked in Thin’s.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00282"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("‘I get a lot of people coming through here. I can’t remember.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00283"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("‘So you took a complete stranger home the other night, you dirty Scottish boy,’ he drawls and tries to touch my hand. Pulling away, I fold my arms in front of me defensively.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00284"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("‘Look, please understand. I don’t want to get involved with you. My life is complicated enough as it is. No offence mate but please, I’d like you to leave me alone.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00285"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("‘I’m not averse to affairs. I’m terribly discreet.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00286"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("I don’t believe this. How can I get it through his thick skull.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00287"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("‘I’m going away. My marriage isn’t working out. I’m moving down to London.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00288"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("He keeps on.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00289"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("‘A long-distance love affair. I’ve never been further down than Manchester. Shocking, eh?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00290"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("I’m finding it very hard not to lose my cool as I imagine braining the bastard against the counter.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00291"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("‘Will you fucking listen to me? I’m sorry if you think I led you on but Jesus, you pick up a complete stranger in the street and fuck them, what do you expect?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00292"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("A blushing schoolboy appears from nowhere and purchases a book on Gallipoli. The creep stands smirking, intensifying the boy’s discomfort. What if he tells someone? What if he tells his mother the man in the book shop picks up young guys? The door tings shut again. Creep leans on the counter and in towards me. I back away.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00294"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("‘So when are you leaving then? When can I visit you?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00295"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("No more.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00296"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("‘Look, will you fuck off? What do I have to fucking say to you? Get out my fucking face.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00297"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("The bastard’s lip starts trembling, I don’t believe it. A tear runs down his idiot face as he turns and makes for the door, roaring ‘cunt’ at me as he departs. Never has that word sounded so good.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00014"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("14")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00298"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("There’s no sign of him when I close up at five, so I walk home to reassert my freedom. A couple of times on the way back I imagine I see him in people who look nothing like him. When I turn into Northumberland Street and he’s not there, I sense that he could finally have got the message.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00299"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("As I enter the flat I hear Hope in the living room talking to someone. For a second I imagine the scene in "), _c('i', [_vm._v("Fatal")]), _vm._v(" "), _c('i', [_vm._v("Attraction")]), _vm._v(" when gorgeous Michael Douglas comes home and Glenn Close is there pretending she wants to buy the house. Then I hear another female speaking. I pop my head round the door and see Hope sitting with a woman in her thirties and a toddler. The roses are in a vase by the table. Hope gestures to them and smiles.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00300"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("‘Martin dear, this is my niece, Jacqueline, Angus’s sister. Get that nice bottle of Chardonnay out the fridge and join us. This is Angus’s friend, he’s flat-hunting at the moment ")]), _c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }, [_vm._v("and being an extremely pleasant house guest in the meantime.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00301"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }, [_vm._v("Telling them I’ll be through in a few minutes, I rifle my pockets for my gear as I walk up the hall to my room. I need a joint before I’m subjected to fucking babies.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00302"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }, [_vm._v("As it turns out, the child is not too bad. Jacqueline is a crushing bore though. Nobody else wants a drink so I pour myself one and sit in a glorious little stupor, watching the kid doing its kiddish things. It is into everything. Hope seems unconcerned as it staggers around pocketing keys and trying to chew everything in its wake. Is he hyperactive or are they all like this? Jacqueline seems very experienced in the art of sustaining a conversation whilst running about fretting over the wee monster. Jason (and the Argonauts? The Golden Fleece? Surely not Donovan) is playing to an audience and throws a tantrum every time our attention wavers.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00303"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }, [_vm._v("After about an hour, and three quarters of a bottle of Chardonnay he starts getting a bit tired and greety. He keeps lolling about the room then crashing into his mother for a cuddle. Hope looks pretty irritated by now. Jacqueline tries to calm him down by shyly singing ‘Mockingbird’ to him and rocking him gently in her arms. I love croaky, nervous voices like hers, they’re so human. ‘No sing Mummy, please no sing,’ the child pleads. Hope hoots with laughter and the rest of us are soon infected by it. Jason is annoyed that we seem to have got something over on him and starts crying ")]), _c('a', {
    attrs: {
      "id": "pb-rw_51"
    }
  }, [_vm._v("again. Jacqueline notices the renewed look of subdued displeasure on Hope’s face and begins getting her things together and squeezing into her coat.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00304"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_51"
    }
  }, [_vm._v("Hope beckons to me as Jacqueline crawls around on the carpet looking for discarded toys. I follow her through to her bedroom. She goes to the other side of the bed, rummages around, puts a bit of wood against the wall and pulls out a wad of notes, counting through them, 20, 40 … 180, 190, "), _c('i', [_vm._v("£")]), _vm._v("200. She slips it in the pocket of her blouse, then tears another twenty off and hands it to me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00305"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_51"
    }
  }, [_vm._v("‘You wouldn’t be a dear and pop out and get me a bottle of Ten-Year-Old Macallan’s would you? I need to have a word with Jacqueline on her own …’ she gestures to the money in her pocket, ‘… man trouble,’ and winks at me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00306"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_51"
    }
  }, [_vm._v("She squeezes my hand as she sees me out the flat. Jesus, why was she so obvious about where she keeps money? Is she testing me or something? And "), _c('i', [_vm._v("£")]), _vm._v("200 to a niece she never sees, just like that. I don’t need her money. I don’t want it. There’s no way I’d steal from her, she’s too kind. Stealing is a form of revenge.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00307"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_51"
    }
  }, [_vm._v("As I open the stair door my suppressed trepidation hits me again but the street is still clear. Once I’m sure that nonsense is behind me, I’ll be able to put my real feelings for Hope in perspective. It was funny, just the look she gave me tonight when she was telling Jacqueline about me flat-hunting. There are strange erotic sparks between us, I’m sure of it.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00309"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("When I get back, Jacqueline has gone and Hope is lying back on the settee with "), _c('i', [_vm._v("La Traviata")]), _vm._v(" blaring. Her arm rises like a charmed snake and she points at two tumblers on the table. Pulling the Macallan’s out the bag, I pour us a couple of measures.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00310"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("‘Straight tonight, madam?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00311"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("‘Indeed, but twist up one of your little mary-janes as a chaser.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00312"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("We lounge back on the settee together, tingle with the whisky and pass the joint to one another as Maria Callas bangs it out. In a matter of days, without trying, our friendship has deepened to such an extent that we feel completely at ease without having to say anything to each other. Nuzzling closer to Hope, she drapes her arm across my shoulders and I snuggle against her upper arm. Her skin smells of talcum and fresh air. The heat where my head touches her arms feels like it’s buzzing. I feel utterly replete.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00313"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("We lie huddled up like this for ages until the CD player clicks and the chorus bursts into ‘"), _c('i', [_vm._v("Dell’invito trescora e’ jia")]), _vm._v("’ "), _c('i', [_vm._v("l’ora")]), _vm._v("’, for what must be the second time. Hope clammers up from the settee and switches it off.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00314"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("Pouring us both another whisky, she gestures to my blow and I obligingly begin rolling another joint.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00315"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("‘Have you ever been to Italy?’ I ask as she sits down again.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00316"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("‘La dentro non ci andrei, – pieno di l’Italiani,’ she says incomprehensibly in a thick Italian accent. ‘… my husband ")]), _c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("worked in Rome for a while before I met him but we never made it over together somehow. Maybe he had another wife there.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00317"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("The mention of her husband, that tiny part of the vast life she had before I met her, gives me a little twinge of jealousy.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00318"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("‘I’m very backward as far as foreign travel is concerned. Holland once, Greece once, France a few times. I’ve a couple of pals just outside Paris I see every now and again (eight years ago!). It just seems such a lot of money to spend before you buy your first pint.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00319"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("Hope becomes animated.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00320"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("‘Oh I love France – Paris, Fontainebleau, Marseilles … Provence used to be lovely too until they BBC’d it and attracted all the riff raff.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00321"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("‘I’d love to go there with you some time. I could save up.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00322"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("Hope waves her hands in front of her like she’s doing the Charleston.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00323"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("‘That’s a wonderful idea. I’d love a little break. When could you get time off work?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00324"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("‘I’m owed loads of annual leave but I’m always afraid to take it in case the place goes to pieces without me. Plus, he doesn’t pay me when I’m off.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00325"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("‘Pah, don’t worry about money, for God’s sake.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00326"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("‘I’d like to take you, though. If I put a bit away each week we could go there for the next millennium. But you ")]), _c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("know, I like to pay my own way. I feel bad enough as it is about you not taking anything off me for staying here.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00327"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("She dismisses me with a wave of the hand.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00328"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("‘Pay me back a pound a month if it bothers you that much. I’m not going to go hungry without it, put it that way.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00329"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("‘Oh, but that’s terrible.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00330"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("She looks at me as if I’m mad.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00331"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("‘What’s terrible about it? Is the thought of setting Paris alight with me so awful? Don’t be so bloody silly – when could you get time off? In a month? Next week?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00332"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("‘Whenever, I just need to give a couple of days’ notice and my boss can get his wife to watch the place.’ I also need time to go through the books with a nit comb.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00333"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("She bangs her glass against mine.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00334"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("‘Leave it to me. Vive la France.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00335"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("We say goodnight at the living room door. Thoughts of a possible free holiday and all the lush times we might have keep me awake for hours. I’m also dying to see Roxanne and Jonathan. We shared a flat for two years when I was studying in London. There’s been an open invite since I was last there over eight years ago. Something else always comes up though and work’s usually good in the summer as the tourists are such idiots with money.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00015"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("15")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00336"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("I’m woken up at 2.34 by a right racket out in the street – loud voices, lights flashing through the chinks in the shutters and ")]), _c('a', {
    attrs: {
      "id": "pb-rw_55"
    }
  }, [_vm._v("the roar of machinery. It had better not be those cable TV bastards digging up the road at this time of the morning. I stumble out of bed and over to the window. It’s a fucking fire engine, putting out a fire in one of the bins. Such an unbelievable amount of noise for a pissing little fire in a bucket. As I slump back to bed I feel wide awake with anger.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00337"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_55"
    }
  }, [_vm._v("Once I’m back under the duvet, I realise I’ve left the shutters open but by then I’m getting the fear and don’t want to go back over to the window again. Why did a bucket go on fire in a New Town street at half two on a Wednesday morning? It had to be deliberate. Surely that wanker wouldn’t pull a stunt like that. The bucket is only about fifteen feet away from the steps up to the flat. He wouldn’t, would he? Why am I imagining this? There’s been no sign of him since yesterday afternoon. He would have rung the buzzer or been outside when I got home from work. Oh fuck. I bet he’s been along at the Phoenix. Fuck fuck fuck. Wild imaginings about the bastard keep me awake for most of the remainder of the night. When the alarm goes off at eight I feel like I’ve only just shut my eyes.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00016"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_55"
    }
  }, [_vm._v("16")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00338"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_55"
    }
  }, [_vm._v("Hope phones me about eleven to say she’s booked two open-ended flights to Charles de Gaulle. We can travel any time after tomorrow if there’s space on the flights. It’s off-peak so we shouldn’t have any trouble getting a hotel at the last minute. This time of year it’s probably only people over on ")]), _c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("booze cruises anyway. Hope wants to keep our holiday a secret until we get back in case anyone else tries to get in on the act at the last minute. I can’t wait for us to be alone together, to be forced to really get to know one another. If we get on, I am definitely going to go for it.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00339"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("When I try to phone my boss, I discover he’s been in hospital for the past three days – the cancer’s gone into his stomach. What’ll happen to the shop if he dies? I’d never get another job where I made so much for doing so little. Its almost like this place is part of my identity now. Maybe I should visit him before we go away, see what he’s planning to do with it before he pops his clogs. Maybe Hope would buy him out. Mmmh. His daughter, Angela, can’t cover for me until next Tuesday though which is a pain in the pisser. Does he have to fucking die when I get the chance of my first holiday in years? I don’t tell her where I’m going as I don’t want her asking about it when I get back.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00340"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("I’ve just put the phone down when it rings again.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00341"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("‘Look Martin, I’m sorry, ok.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00342"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("‘Who is this?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00343"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("‘Raymond,’ says a hurt-sounding voice.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00344"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("‘Raymond who?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00345"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("‘The person you told to fuck off yesterday. Have you forgotten me already?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00346"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("Oh Jesus, I don’t believe it. My hackles are up immediately.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00348"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("‘Look, can I see you? Just once more, please? When are you going away?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00349"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("Fuck, how does he know? Then I remember my lie about London.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00350"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("‘Tomorrow, after work, so I really don’t have time to meet you.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00351"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("‘But I need to, sweetheart. You don’t understand, I can’t see past you … I can’t think straight.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00352"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("Oh, for heaven’s sake.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00353"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("‘Look, I’m sorry mate but there’s nothing I can do. Give me your address and I’ll get in touch when I’m settled.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00354"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("‘Really? You won’t though, will you? I’ll never hear from you again. Please Martin, let me see you. I could pop along now. I could help you take your stuff to the station tomorrow …’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00355"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("‘No, please, don’t come along here. I don’t want you in here. Just leave it, for fuck’s sake?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00356"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("‘What time’s your train tomorrow? I could meet you at the station. Just five minutes, please?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00357"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("It goes on and on like this for about ten minutes. I tell him to fuck off and die and put the phone down on him a couple of times but he just rings back immediately. Why am I tied up in knots by this stupid lie now? Fuck. In desperation, I tell him I’m leaving at six, going from work so I’ll be straight on the train. He insists he’s going to be there though, no matter what I say he insists and finally hangs up.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00358"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("Now if I’m not there at six he’ll know it was a lie. This ")]), _c('a', {
    attrs: {
      "id": "pb-rw_58"
    }
  }, [_vm._v("will just go on for fucking ever. I’m actually toying with the idea of saying goodbye, getting on the fucking train for one stop, then coming back again but it seems an absolutely ridiculous thing to have to do for that cunt. If I can just get his focus off Northumberland Street, stop him lurking around so near to Hope. Other than my idea with the train, I can think of no other solution. It is utterly flawed, however, as I’ll no doubt bump into the bastard the next day.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00359"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_58"
    }
  }, [_vm._v("Perhaps if I can keep a low profile till we go away next week. Jesus, I can always just take a sickie off work. My attendance record is understandably impeccable and they can’t sack me anyway, who would take over? I’m sure Angela would just love to commute from Stirling every day, not. She hates when she has to cover for me. If they have to close the shop and ugly boy goes round there looking for me it’ll make my story more convincing.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00360"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_58"
    }
  }, [_vm._v("Spurred on by my own resolve, I phone GNER and book a day return to Berwick on my debit card which I’ve to pick up at 5.30 tomorrow. I just want this sodding saga cleared up before we go away.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00361"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_58"
    }
  }, [_vm._v("As I close up the shop at five I realise I’ve forgotten to pilfer anything with all this shit to think about. Hastily scribbling a few books through the ledger that have been on the shelf for months, I take "), _c('i', [_vm._v("£")]), _vm._v("30 for blow. My booty from yesterday’s still in my back pocket and I can go daft for holiday money tomorrow.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00363"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_59"
    }
  }, [_vm._v("Having left the safety of the shop, the unguardedness of the street summons feelings of acute anxiety akin to a massive whitey. Escaping into a taxi, I get the driver to take me to Davie’s in Whitson for some gear and to get me out of the stress of the city centre for a while. Fucking "), _c('i', [_vm._v("£")]), _vm._v("9 as well – I must stop jumping in and out of cabs or else steal my old dear’s disabled pass.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00364"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_59"
    }
  }, [_vm._v("Out of politeness I have a couple of joints with Davie, but my nerves are so shot I can only manage a few grunts of conversation. Davie’s not much of a talker anyway, it’s way too much effort for him. Thank God we have "), _c('i', [_vm._v("The ")]), _c('i', [_vm._v("Simpsons")]), _vm._v(" on to sustain us. Then I begin getting these involuntary spasms in my left leg and it starts shooting out in front of me. Davie just looks on impassively as if this happens to him all the time. Before long the lack of communication is depressing me so I leave.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00365"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_59"
    }
  }, [_vm._v("As I open the stair door, I see a 21 coming and sprint to the bus stop just in time to save myself from phoning 999 again. As we pull away I see more satellite dishes than I ever have in my life.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00366"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_59"
    }
  }, [_vm._v("Hope is out at a writing workshop when I get back. I’d forgotten all about it but it’s convenient. Half-filling two holdalls with books, I stick a few shirts on top, just to give the impression they’re full. To avoid having to get them out the house without Hope seeing me in the morning, I put them in the cellar at the bottom of the stair. Although this is probably the stupidest idea I’ve ever had ")]), _c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("I’m trying very hard to get into it, just to see if I can pull it off.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00367"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("Hope’s left me some casserole which looks gorgeous but my hunger is making me nauseous so I place it tactfully in an old bread bag at the bottom of the bin. When was the last time I actually ate anything? I’ve no idea. I occasionally have a Mars Bar with my coffee at lunchtime but I didn’t even manage that this morning. The bottle of Chablis in the fridge, however, is another matter.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00368"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("It’s times like this I really miss having a telly. Without such a distraction I’m soon worrying about everything again and my proposed plan of action seems sillier, the more I think about it.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00369"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("When Hope comes in at midnight, I’m sitting dozing on the settee, exhausted by my procrastination earlier. Leaning over me, she kisses my forehead. The smell of whisky on her breath explains her wide-awake radiance.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00370"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("‘The tutor didn’t turn up so we all went to a pub, I’m quite pissed. A real man’s bar, it was … I liked it. Real people can be frightfully entertaining sometimes. They just come out with it, don’t they?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00371"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("Feelings of animosity towards whoever she’s been out with start bouncing around inside my head. Why didn’t she phone to say where she was? I’d have phoned her and invited her to join me. Stop it, stop it. Why am I getting like this. I’ve not even shagged her yet?")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00372"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("‘I’m on annual leave from tomorrow night,’ I lie, whitely.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00374"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("Hope claps her hands together.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00375"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("‘That’s wonderful.’ She looks at her watch, ‘Oh, I suppose it’s too late to phone the airport now, isn’t it?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00376"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("And whose fault is that?")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00377"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("‘There’s a couple of things I have to do before we go anyway. How about Saturday, if there’s flights available?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00378"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("‘Fine by me. I’ll call a couple of hotels I know in the morning. Super. Anyway, you’re not going to believe some of the things I overheard in that pub …’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00379"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("I’ve no desire to hear about her new pals. Her enthusiasm for them is stressing me out. I stroke my temples melodramatically.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00380"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("‘Sorry, Hope, I’ve had this migraine coming on for the last half hour. I’m going to have to lie down. Tell me tomorrow, eh?’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00381"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("She pretends to look hurt. God, I hate the mind fucks you give yourself when you’re emotionally involved with someone.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00382"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("‘Poor dear. There’s some out-of-date DF118s in the bathroom cabinet if they’d help.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00383"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("DF118s! I don’t really have a migraine but I help myself to six, swallow two and put the rest in a little inkwell in my room. It feels wonderful to be in bed. If I could just stay here for a few months. That’s what I’ll do on Friday, keep a low profile. Will she book single rooms or a double I wonder? She didn’t even ask me. If I just think of it all as an adventure. It is an adventure. The thing at the station tomorrow ")]), _c('a', {
    attrs: {
      "id": "pb-rw_62"
    }
  }, [_vm._v("is part of it. It’s sort of exciting, I suppose. The DFs start to take hold really quickly. I’m having really disgusting fantasies about Hope by the time I fall asleep.")])]), _c('h2', {
    attrs: {
      "id": "rw-h2_127430-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_62"
    }
  }, [_vm._v("17")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_127430-00384"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_62"
    }
  }, [_vm._v("In the morning, she’s not up (no doubt hungover) by the time I go to work. I leave a note on the telephone table saying, ‘back late’ – deliberately unspecific to get her back for not calling last night. Only taking enough money with me for a taxi, I count through the rest – "), _c('i', [_vm._v("£")]), _vm._v("440. That’s not forgetting the two grand in my Savings Account. ‘This is going to be some fucking holiday’ I think as I stuff the wad in a sock.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00385"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_62"
    }
  }, [_vm._v("Having retrieved my holdalls from the cellar, I struggle out with them, feeling stupider by the second. As I turn into the positively mountainous Dublin Street, my arms are aching from the ridiculously heavy bags. Taxis are whizzing by on Queen Street but I have to scale the worst of it before I finally manage to stop one.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00386"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_62"
    }
  }, [_vm._v("Work is a nightmare, as I have to square the place up, make the accounts looks semi-respectable, run through loads of fucking figures to make sure I’ve covered myself on everything. Every time the door goes I feel like Anne Frank. There’s loads of students in during the morning, giggling, talking very loud and constantly asking for things, making me work my arse off for piddling little "), _c('i', [_vm._v("£")]), _vm._v("1.50 paperbacks.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00387"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_62"
    }
  }, [_vm._v("By mid-afternoon I’ve not managed to make a penny ")]), _c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }, [_vm._v("for myself. A guy comes in with a carrier bag full of photography books – Ansen Adams, Weegee, Cartier-Bresson, but I can’t find a fucking pencil anywhere. He lends me his pen and I know I’m going to have to make at least "), _c('i', [_vm._v("£")]), _vm._v("100 or nothing at all on the deal. Utterly offended by my initial offer of a tenner, he says something like "), _c('i', [_vm._v("£")]), _vm._v("90. Although the books are worth five times that, this could be my only chance of the day. It takes me about twenty minutes to haggle him down to "), _c('i', [_vm._v("£")]), _vm._v("25. I respect him for holding out so long but business is business. I’m wasted in this job, I should be on Wall Street.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00388"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }, [_vm._v("Any empathy I had with the guy disappears when I notice he’s put the figure in the book himself, when he was signing it. Fuck, there’s barely room for a ‘1’ in there and I was counting on a ‘2’. I’ll need to watch him if he comes in again. He’s probably worked in a bookshop and knows the form. It’s nearly half three by the time he leaves and I still have to do something with all the books I’ve been buying and not bothering to display for the past few months. I’m sweating like a bastard by the time I close up at five, a mere hundred pounds richer.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00389"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }, [_vm._v("The stupid bloody bags mean I have to get yet another taxi to the station. It’ll be worth it though, if it gets that bastard off my back, at least until he’s calmed down about the whole thing. It should flatter me that someone’s so into me, but I’m from Edinburgh, you know, I hate people invading my space.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00391"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("There’s a long queue at the booking office. I should have told the bastard to stand in the queue for me while he was waiting, although he doesn’t seem to be here yet, anyway. That’s fine though, the less time I have to spend with him the better.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00392"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("I’m in a queue for ten minutes before I realise there’s a separate desk for previously paid-for tickets. They serve me immediately as apparently no-one else has the savvy to pay in advance.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00393"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("Leaving the booking hall, I walk down to the platform, but still can’t see him. In WH Smith’s, I thumb the glossies for ten minutes, then for extra authenticity, buy a copy of "), _c('i', [_vm._v("Time Out")]), _vm._v(". Still no sign. It’s now 5.45. Walking round to the Rendezvous Point, I scan the crowd and sit down. The smell from the bin next to me turns my stomach. I walk back over to the platform. The tannoy announces that the train is arriving. Lots of people waiting, but not him.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00394"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("At 5.52 I walk back over to the shop, then have another quick look in the booking hall. Jesus, I don’t believe this, I’m going to fucking Berwick for his benefit and he’s not even here. What will I do? I’ve wasted "), _c('i', [_vm._v("£")]), _vm._v("15 on a fucking ticket. This isn’t on.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00395"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("5.58 and people are getting on the train, doors are being slammed, the engine is starting to roar. Will I just go home? Stand in that fucking queue again to get a refund on my ticket? What if he’s watching me? That’s it, he’s fucking watching to see if I go or not.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00397"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_65"
    }
  }, [_vm._v("The guard asks me if I’m getting on. I stand like a bewildered prick for a few seconds, then he asks me again. Utterly humiliated, I jump on. The door is slammed behind me and the fucking train is off before I even have time to think about it.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00398"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_65"
    }
  }, [_vm._v("Clambering up to the smoking carriage in complete shock, I drop into a seat and light up a Silk Cut. As Edinburgh slowly disappears, I still can’t quite believe what I’m doing. The whole journey down I’m raging at myself for doing something so fucking idiotic. It’s an hour’s wait at Berwick to get the train back, and once I’m on it I crash out, sick of thinking.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00399"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_65"
    }
  }, [_vm._v("It’s only thanks to some noisy squaddies getting on at Waverley that my evening doesn’t end in Aberdeen. Then I’m hawking those bloody bags back down the bloody platform again, thinking that if I see him now I’ll fucking kill myself. I try phoning the flat but there’s no answer.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00400"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_65"
    }
  }, [_vm._v("It’s nine o’clock by the time I get my third taxi of the day. I must learn to drive, I hate having to rely on these fuckers. As I get dropped off I’m relieved to see that the lights are all off in the flat, so I can get the bags in again undetected.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00401"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_65"
    }
  }, [_vm._v("My note to Hope has gone from the telephone table, but there’s an envelope with my name on it – just ‘Martin’. It’s definitely not Hope’s flamboyant script, in fact I know exactly who it’s from the second I see it. He must have put it through the fucking door. Please make Hope have been ")]), _c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_vm._v("out when he turned up. There’s no note to say where she is and it makes me feel stupid for bothering to tell her I’d be late. Taking the envelope through to my room I need a joint before I can face it.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00402"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_vm._v("There’s a flimsy bit of lined paper, torn out of a notebook, inside, folded once. All that is written on it is ‘vous l’avez voulu’. What the fuck does that mean? Why didn’t I nick a French phrasebook from work for next week? Has he found out about Paris? How long has it been lying there? Maybe he couldn’t make it to the station. Why would he bring it here though, if he thought I’d be gone? Please don’t let Hope have met him. I don’t want to have to explain him to her.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00403"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_vm._v("Looking out onto the empty street as I finish the joint, it begins to really irritate me that Hope hasn’t left me a note. Maybe she phoned while I was out. Going into the hall, I do a 1471 but it’s the fucking pay phone I called from at the station.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00404"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_vm._v("Thinking she might have left a note in the living room, I open the door. A black shape lunges at me from nowhere. The shock knocks me over. The next thing I’m aware of is something licking my face. It’s his dog. It’s his fucking dog. He’s fucking in here.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00405"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_vm._v("Thrusting myself into the room, I expect him to be sitting there with a fucking smug look on his face but it’s empty. There are cushions all over the floor and it smells of piss. My whole body begins trembling, like I’m going to have ")]), _c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_vm._v("a fit, as I stagger up and check the kitchen, then the bathroom.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00406"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_vm._v("They are both in Hope’s bed. As I walk round taking it all in, it seems strangely normal. Hope’s skin is yellow and plastic-looking, her throat discoloured by what looks like a string of lovebites. They are the same colour as the inordinately large tongue which lollops at the side of her mouth. Her eyes are open and pleading with me to do something. I close them.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00407"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_vm._v("Raymond is lying sideways over her. His skin is much darker than hers but yellow still seeps through. A huge, wet, purple carnation blossoms out on the blue sheet beneath his hand. The dog jumps up on the bed and tries to lick the death from his face. It is like something out of a Japanese horror film. I think about the air tickets on the mantelpiece and the money under the floor. I think about calling Shirley, or dialling 999. Then I think about me being just another cunt getting carted into a prison van on the Scottish news. Nah, I don’t think so.")])]), _c('p', {
    attrs: {
      "id": "rw-p_127430-00408"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-386a8b9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a9781847677099_chapter_01.vue
// module id = 69
// module chunks = 0